import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PubnubMessageEvent } from 'src/app/shared/pubnub/pubnub-types';
import { AppState } from 'src/store/appstate';
import { selectPubnubMessage } from 'src/store/pubnub/pubnub-store.model';

@Component({
  selector: 'tcs-pubnub-message',
  templateUrl: './pubnub-message.component.html',
  styleUrls: ['./pubnub-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PubnubMessageComponent {
  public message$: Observable<PubnubMessageEvent | null>;

  constructor(store: Store<AppState>) {
    this.message$ = store.select(selectPubnubMessage());
  }
}
